import cocksoda from '../images/supermarket/cocksoda.jpg'
import LatoMilk from '../images/supermarket/milk.jpg'
import Soap from '../images/supermarket/omo.jpg'
import pasta from '../images/supermarket/pasta.jpg'
import sugar from '../images/supermarket/sugar.jpg'
import earphones from '../images/pnones_tablets/earphones.jpg'
import iphone from '../images/pnones_tablets/iphone 12.jpg'
import nokia from '../images/pnones_tablets/nokia.jpg'
import techno from '../images/pnones_tablets/techno.jpg'
import tablet from '../images/pnones_tablets/tablet.jpg'
import speaker1 from '../images/electronics/speaker1.jpg'
import speaker2 from '../images/electronics/speaker2.jpg'
import armband from '../images/sports/armband.jpg'
import ball from '../images/sports/ball.jpg'
import ball2 from '../images/sports/ball2.jpg'
import fitness from '../images/sports/fitness.jpg'
import tv2 from '../images/electronics/tv2.jpg'
import tv1 from '../images/electronics/tv1.jpg'
import waisttraner from '../images/sports/waisttraner.jpg'
import dell from '../images/computing/dell.jpg'
import fd from '../images/computing/Fdisk.jpg'
import HDD from '../images/computing/HDD.jpg'
import mouse from '../images/computing/mouse.jpg'
import printer from '../images/computing/printer.jpg'


  export const data = [
  {
       "id": 1,
        "category":"Supermarket",
        "product": "cocksoda",
        "image": cocksoda,
        "desc": "Coca-cola Soda, 2 Liters",
        "price": 3800,
        "star": 3
      },
      {
        "id": 2,
        "category":"Supermarket",
        "product": "Lato Milk",
        "image": LatoMilk,
        "desc": "Lato Milk - 400g",
        "price": 13667,
        "star": 4
      },
      {
        "id": 3,
        "category":"Supermarket",
        "product": "Soap",
        "image": Soap,
        "desc": "Omo Omo Fast Action Hand Washing Powder - 1kg",
        "price": 5900,
        "star": 5
      },
      {
        "id": 4,
        "category":"Supermarket",
        "product": "Pasta",
        "image": pasta,
        "desc": "Golda Penne Rigate - 500g",
        "price": 4900,
        "star": 3
      },
      {
        "id": 5,
        "category":"Supermarket",
        "product": "Sugar",
        "image": sugar,
        "desc": "Kinyara Sugar Kinyara Irresistibly Sweet Sugar - 1Kg",
        "price": 3400,
        "star": 4
      },


      
      {
        id: 6,
         "category":"Phones and Tablets",
         "product": "Earphones ",
         "image": earphones,
         "desc": "Generic Bluetooth Wireless Earphones With Charging Case",
         "price": 18500,
         "star": 1
       },
       {
         id: 10,
         "category":"Phones and Tablets",
         "product": "I phone 12",
         "image": iphone,
         "desc": "I phone 11 pro 2017 8gb ram 168 HD memory",
         "price": 2000000,
         "star": 4
       },
       {
         id: 7,
         "category":"Phones and Tablets",
         "product": "Nokia",
         "image": nokia,
         "desc": "Nokia 105 DS'' Dual Sim, FM Radio, Black",
         "price": 5900,
         "star": 3
       },
       {
         id: 8,
         "category":"Phones and Tablets",
         "product": "Techno",
         "image": techno,
         "desc": "Tecno Pop 4 - 6.0 2GB RAM 5000mAh - Green",
         "price": 330000,
         "star": 4
       },
       {
         id: 9,
         "category":"Phones and Tablets",
         "product": "Tablet",
         "image": tablet,
         "desc": "Note 4 Plus 4G LTE Tablet 4GB RAM 64GB Dual Sim",
         "price": 350000,
         "star": 5
       },



       {
        id: 0,
         "category":"Electronics",
         "product": "Speaker ",
         "image": speaker1,
         "desc": "Golden Tech 5.1Sub-woofer - Black",
         "price": 455000,
         "star": 2
       },
       {
         id: 11,
         "category":"Electronics",
         "product": "Speaker",
         "image": speaker2,
         "desc": "Generic GO 2 Speaker Wireless Portable Music Player IPX7",
         "price": 118623,
         "star": 1
       },
       {
         id: 12,
         "category":"Electronics",
         "product": "Hisense",
         "image": tv1,
         "desc": "Hisense 55'' Inch 4K Ultra HD Smart TV - Black",
         "price": 2590000,
         "star": 3
       },
       {
         id: 13,
         "category":"Electronics",
         "product": "Samsung",
         "image": tv2,
         "desc": "Samsung 55'', Smart LED TV, Curve UHD TV4K - Black",
         "price": 5500000,
         "star": 3
       },
       {
         id: 14,
         "category":"Electronics",
         "product": "Hisense",
         "image": tv1,
         "desc": "Hisense 55'' Inch 4K Ultra HD",
         "price": 550000,
         "star": 2
       },



       {
        id: 15,
         "category":"Sports",
         "product": "Armband ",
         "image": armband,
         "desc": "Other Captain's - Black.",
         "price": 18000,
         "star": 2
       },
       {
         id: 16,
         "category":"Sports",
         "product": "Generic Ball",
         "image": ball,
         "desc": "Generic Spectacular Size 5 Football /Soccer Ball - White/Blue",
         "price": 35000,
         "star": 1
       },
       {
         id: 17,
         "category":"Sports",
         "product": "Ball",
         "image": ball2,
         "desc": "Spectacular Size 5 Football",
         "price": 30000,
         "star": 4
       },
       {
         id: "sg4",
         "category":"Sports",
         "product": "Trainner",
         "image": fitness,
         "desc": "Generic Electric Muscle Training Abdominal Machine - Black",
         "price": 24700,
         "star": "4"
       },
       {
        id: 18,
         "category":"Sports",
         "product": "Waist traner",
         "image": waisttraner,
         "desc": "Generic Waist Trainer Belt Waist Cincher Trimmer - Sport Girdle Belt",
         "price": 55426,
         "star": 5
       }, 




       {
        id: 19,
         "category":"computing",
         "product": "Dell ",
         "image": dell,
         "desc": "DELL DELL Refurbished  Core i5 4GB RAM 500GB ROM - Black",
         "price": 859020,
         "star": 2
       },
       {
         id: 20,
         "category":"computing",
         "product": "Scan Disk",
         "image": fd,
         "desc": "Sandisk 16GB Sandisk 2.0 Cruzerblade Flash Disk - Red,Black",
         "price": 19000,
         "star": 1
       },
       {
         id: 23,
         "category":"computing",
         "product": "Hard Disk",
         "image": HDD,
         "desc": "Transcend 1TB Transcend Portable USB 3.0 Hard Disk - Black, Green",
         "price": 210000,
         "star": 5
       },
       {
         id: 24,
         "category":"computing",
         "product": "Mouse",
         "image": mouse,
         "desc": "Generic 2.4 GHz Ultra Slim Wireless Mouse - Black",
         "price": 15000,
         "star": 4
       },
       {
         id: 28,
         "category":"computing",
         "product": "Printer",
         "image": printer,
         "desc": "Hp Deskjet All-in-One Inkjet Printer- White",
         "price": 175000,
         "star": 3
       } 

]
